import { useState } from 'react'
import type { ValidationMethod } from '../../features/validation'

export function useValidationMethod() {
  const [selectedMethod, setSelectedMethod] = useState<ValidationMethod | null>(null)

  const methodLabel = selectedMethod === 'survey' ? 'Survey' : 'Interview'

  return {
    selectedMethod,
    setSelectedMethod,
    methodLabel,
  }
}
